














































import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldSeasons'

  vue:
    props: ['value', 'errors']

    data: ->
      seasons = @value || []
      seasons: seasons
      isActive: seasons.length > 0
      seasonsTableData: []

    mounted: ->
      @parseSeasonsToTableData()

    methods:
      hiAdd: ->
        @add()
        @parseSeasonsToTableData()
        @inputChanged()

      hiRemove: (index) ->
        @remove index
        @parseSeasonsToTableData()
        @inputChanged()

      hiInputChanged: ->
        @parseTableDataToSeasons()
        @inputChanged()

      add: ->
        name = "Season #{@seasons.length + 1}"
        today = dayjs()
        start_day = parseInt(today.format('DD'))
        start_month = parseInt(today.format('MM'))
        end_day = parseInt(today.format('DD'))
        end_month = parseInt(today.format('MM'))
        @seasons.push { name, start_day, start_month, end_day, end_month }

      remove: (index) ->
        @seasons.splice index, 1

      clear: ->
        @seasons = []

      parseSeasonsToTableData: ->
        @seasonsTableData = @seasons.map((season) =>
          year = dayjs().get('year')
          startsOn = dayjs("#{year}-#{season.start_month}-#{season.start_day}").toDate()
          endsOn = dayjs("#{year}-#{season.end_month}-#{season.end_day}").toDate()

          id: season.id
          data: season
          name: season.name
          startsOn: startsOn
          endsOn: endsOn
        )

      parseTableDataToSeasons: ->
        @seasons = @seasonsTableData.map((row) =>
          startsOn = dayjs(row.startsOn)
          endsOn = dayjs(row.endsOn)

          {
            ...row.data,
            name: row.name
            start_day: startsOn.format('DD')
            start_month: startsOn.format('MM')
            end_day: endsOn.format('DD')
            end_month: endsOn.format('MM')
          }
        )

      inputChanged: ->
        @$emit 'input', @seasons
        @$emit 'change', @seasons

    watch:
      isActive: (active) ->
        if active
          if @seasons.length is 0
            @add()
            @parseSeasonsToTableData()
        else
          @clear()
        @inputChanged()

export default VueOptions.vue settings
